export const CALLBACK_ERROR = "An error occurred while executing your controller's callback";
export const SELECTOR_ERROR = "An error occurred inside your controller's selector";
export const PREDICATE_ERROR = "An error occurred inside your controller's predicate";

const defaultCondition = ({ currentProp, previousProp }) => currentProp !== previousProp;

export const controlUpdates = (controllers, getState) => () => {
  const state = getState();
  const keys = Object.keys(controllers);

  for (let i = 0; i < keys.length; i += 1) {
    const controller = controllers[keys[i]];
    const { condition, selector, callback, _previousProp } = controller;
    const predicate = condition || defaultCondition;

    let currentProp;
    try {
      currentProp = selector(state);
    } catch (error) {
      throw new Error(`${SELECTOR_ERROR} "${keys[i]}": ${error.stack}`);
    }

    let shouldUpdate;
    try {
      shouldUpdate = predicate({ previousProp: _previousProp, currentProp });
    } catch (error) {
      throw new Error(`${PREDICATE_ERROR} "${keys[i]}": ${error.stack}`);
    }

    if (shouldUpdate) {
      controller._previousProp = currentProp;
      callback(currentProp);
    }
  }
};
